const SET_VALUES = (state, values) => {
  state.values = values
}

const SET_VALUE = (state, value) => {
  state.value = value
}

const SET_QUESTIONS = (state, data) => {
  state.questions = data
}

const PUSH = (state, data) => {
  state.values = state.values.concat(data)
}

const UPDATE = (state, data) => {
  data.values.forEach(value => {
    let idx = state.values.findIndex(x => x.id === value.id)
    state.values[idx] = value
  })
}

const REMOVE = (state, valueId) => {
  state.values.splice(state.values.findIndex(x => x.id === valueId), 1)
}

const CLEAR = (state) => {
  state.values = []
}

const TOGGLE_RELOADING = (state) => {
  state.reloading = !state.reloading
}

const PUSH_QUESTION = (state, data) => {
  data.forEach((value) => {
    let node = state.questions.find((question) => {
      return question.value === value.value &&
        question.section === value.section &&
        question.number === value.number &&
        question.kv_number === value.kv_number &&
        question.dossier_number === value.dossier_number &&
        question.profile_number === value.profile_number &&
        question.category_number === value.category_number
    })

    if (node) {
      node.ids.push(value.id)
      node.bundles.push(value.bundle_id)
    } else {
      state.questions.push({
        ids: [value.id],
        value: value.value,
        number: value.number,
        section: value.section,
        bundles: [value.bundle_id],
        kv_number: value.kv_number,
        dossier_number: value.dossier_number,
        profile_number: value.profile_number,
        category_number: value.category_number
      })
    }
  })
}

const UPDATE_QUESTION = (state, params) => {
  params.values.forEach(question => {
    state.questions[question.index].value = question.value
  })
}

const REMOVE_QUESTION = (state, idx) => {
  state.questions.splice(idx, 1)
}

const COPY = () => {
  console.log('Done')
}

export default {
  PUSH,
  COPY,
  CLEAR,
  UPDATE,
  REMOVE,
  SET_VALUE,
  SET_VALUES,
  SET_QUESTIONS,
  PUSH_QUESTION,
  UPDATE_QUESTION,
  REMOVE_QUESTION,
  TOGGLE_RELOADING
}
